export default function TermosPage() {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="text-3xl font-heading font-bold mb-2">Termos de Uso</h1>
      <p className="text-sm text-muted-foreground mb-8">Última atualização: setembro de 2026</p>

      <div className="prose prose-sm max-w-none space-y-8 text-foreground">

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">1. Sobre a Plataforma</h2>
          <p className="text-muted-foreground leading-relaxed">
            O AgroAluga é uma plataforma de conexão entre produtores rurais que oferecem equipamentos e serviços agrícolas
            e produtores que buscam essas soluções na sua região. A plataforma é operada por pessoa física, com sede
            em Santa Catarina, Brasil, e pode ser acessada pelo endereço <strong>agroaluga.com.br</strong>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">2. Aceitação dos Termos</h2>
          <p className="text-muted-foreground leading-relaxed">
            Ao se cadastrar ou utilizar o AgroAluga, você declara ter lido, compreendido e concordado com estes
            Termos de Uso. Caso não concorde com qualquer disposição, não utilize a plataforma.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">3. Cadastro e Conta</h2>
          <p className="text-muted-foreground leading-relaxed">
            Para utilizar os recursos completos da plataforma, é necessário criar uma conta com informações verdadeiras
            e atualizadas. Você é responsável pela confidencialidade da sua senha e por todas as atividades realizadas
            com sua conta. O AgroAluga reserva-se o direito de encerrar contas que violem estes termos.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">4. Publicação de Anúncios</h2>
          <p className="text-muted-foreground leading-relaxed">Ao publicar um anúncio, o usuário declara que:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li>É proprietário ou tem autorização para anunciar o equipamento ou serviço</li>
            <li>As informações, fotos e preços são verdadeiros e atualizados</li>
            <li>O conteúdo não viola direitos de terceiros nem a legislação brasileira</li>
            <li>Não serão publicados conteúdos ofensivos, enganosos, ilegais ou inadequados</li>
          </ul>
          <p className="text-muted-foreground leading-relaxed mt-3">
            Todos os anúncios passam por moderação antes de serem publicados. O AgroAluga reserva-se o direito
            de recusar ou remover anúncios que violem estas diretrizes, sem necessidade de justificativa prévia.
          </p>
          <p className="text-muted-foreground leading-relaxed mt-3">
            Anúncios possuem validade de 30 (trinta) dias, após os quais expiram automaticamente e podem ser renovados
            pelo anunciante. Anúncios de contas gratuitas expirados são removidos após 7 (sete) dias; anúncios de contas
            com planos pagos permanecem armazenados para renovação até que o anunciante decida removê-los.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">5. Planos, Pagamentos e Cancelamento</h2>
          <p className="text-muted-foreground leading-relaxed">
            O AgroAluga opera em modelo <strong>freemium</strong>: o cadastro e a publicação de até 3 (três) anúncios
            por mês são gratuitos. Para recursos adicionais — mais anúncios, destaques e selo de verificação — são
            oferecidos planos pagos (Plus, Pro e Ultra), com cobrança mensal ou anual.
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li>Os pagamentos são processados pela <strong>Stripe</strong>, provedora de pagamentos que atende aos padrões internacionais de segurança. O AgroAluga não armazena dados completos de cartão.</li>
            <li>Nos planos mensais, a assinatura é renovada automaticamente ao fim de cada ciclo, mediante aviso prévio por e-mail. O usuário pode cancelar a renovação a qualquer momento.</li>
            <li>Nos planos anuais, o pagamento é único, podendo ser parcelado em até 12 (doze) vezes pela Stripe.</li>
            <li>O cancelamento interrompe as renovações futuras. O acesso ao plano permanece ativo até o fim do período já pago, não havendo reembolso proporcional de períodos em curso.</li>
            <li>Solicitações relacionadas a reembolso ou a direitos previstos na legislação de defesa do consumidor podem ser encaminhadas ao suporte pelo e-mail informado nestes Termos e serão analisadas conforme a lei aplicável.</li>
          </ul>
          <p className="text-muted-foreground leading-relaxed mt-3">
            Os valores dos planos podem ser alterados mediante comunicação prévia. Alterações não afetam ciclos já pagos.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">6. Responsabilidade pelas Negociações</h2>
          <p className="text-muted-foreground leading-relaxed">
            O AgroAluga é uma plataforma de conexão e não participa das negociações, contratos ou transações
            realizadas entre usuários. A plataforma não se responsabiliza por:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li>Qualidade, estado ou disponibilidade dos equipamentos e serviços anunciados</li>
            <li>Descumprimento de acordos entre as partes</li>
            <li>Danos causados durante a prestação de serviços ou uso de equipamentos</li>
            <li>Veracidade das informações fornecidas pelos usuários</li>
          </ul>
          <p className="text-muted-foreground leading-relaxed mt-3">
            Recomendamos que todos os acordos sejam formalizados por escrito entre as partes antes da prestação
            do serviço ou entrega do equipamento.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">7. Avaliações</h2>
          <p className="text-muted-foreground leading-relaxed">
            Os usuários que revelarem o contato de um anunciante podem deixar avaliações sobre sua experiência.
            As avaliações devem ser honestas e baseadas em experiências reais. É proibido publicar avaliações
            falsas, difamatórias ou com o objetivo de prejudicar concorrentes. Avaliações que violem estas
            diretrizes podem ser removidas pelo AgroAluga.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">8. Propriedade Intelectual</h2>
          <p className="text-muted-foreground leading-relaxed">
            Todo o conteúdo da plataforma — marca, design, textos e funcionalidades — é de propriedade do
            AgroAluga. Ao publicar fotos e textos na plataforma, o usuário concede ao AgroAluga licença não
            exclusiva para exibir esse conteúdo dentro da plataforma.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">9. Privacidade e Dados</h2>
          <p className="text-muted-foreground leading-relaxed">
            O tratamento de dados pessoais é regido pela nossa <a href="/privacidade" className="text-primary hover:underline">Política de Privacidade</a>,
            em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018). Os dados coletados são
            utilizados para operação da plataforma e não são vendidos a terceiros.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">10. Contato</h2>
          <p className="text-muted-foreground leading-relaxed">
            Para dúvidas, sugestões, reclamações ou solicitações relacionadas a estes termos, planos ou pagamentos,
            entre em contato pelo e-mail:
            <a href="mailto:agroaluga@outlook.com" className="text-primary hover:underline ml-1">agroaluga@outlook.com</a>
          </p>
        </section>

      </div>
    </div>
  );
}
